import type { AccountPersonaDisclosure } from '@confluent/shared/lib/account-persona/disclosure';
import { Badge } from './Badge.js';

/**
 * The AI-simulation disclosure (EU AI Act Art. 50(1)) as a badge: the label, plus "unevaluated" in a warning tone
 * while the persona version has not been evaluated. The disclosure sentence is the tooltip. Never collapsible.
 */
export function DisclosureBadge({ disclosure }: { disclosure: AccountPersonaDisclosure }) {
  return (
    <span className="inline-flex items-center gap-1.5" title={disclosure.text} data-testid="disclosure-badge">
      <Badge variant="accent">{disclosure.label}</Badge>
      {!disclosure.evaluated && <Badge variant="warning">unevaluated</Badge>}
    </span>
  );
}
